module.exports = __webpack_public_path__ + "static/media/BgSignup.c37d2620.png";